import apiCall from "../../axios";
import queryString from "query-string";

const unsnooze = async (data: any) => {
  try {
    let url = `operator/snooze`;
    const res = await apiCall("POST", url, data);
    return res.data;
  } catch (e) {
    if (e) return e;
    return { error: "Unknown Error" };
  }
};

export default unsnooze;
